module.exports = __webpack_public_path__ + "img/semimagem.fa55a080.jpg";